import React, { Fragment } from 'react';
import { UserEntry } from './UserEntry';

export const UserEntries = ({ users, handleDelete, handleEdit, handleTokensEdit }) => {
   
    const renderUsers = () => {
        const usersRendered = users.map(user => {
            return <UserEntry key={user.userId} user={user} handleDelete={handleDelete} handleEdit={handleEdit} handleTokensEdit={handleTokensEdit}/>
        });
        
        return <Fragment>
                {usersRendered}
            </Fragment>;
    }

    return (
        <div>
            <table className="table table-striped table-bordered my-2">
                <thead className="thead-dark">
                    <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Description</th>
                        <th scope="col">Username</th>
                        <th scope="col">Password</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {renderUsers()}
                </tbody>
            </table>           
        </div>
    )
}